import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Type", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Item", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Image", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Time Unit", -1)
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "Time Duration", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dt", null, "Publish Time", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "Unpublish Time", -1)
const _hoisted_16 = { class: "card-footer bg-white border border-light" }
const _hoisted_17 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_image_holder = _resolveComponent("app-image-holder")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Promotion Plan Detail "
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.Options.Type, _ctx.model.type)
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("dd", null, [
              _createVNode(_component_router_link, {
                to: _ctx.model.itemLink
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.model.itemName), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("dd", null, [
              _createVNode(_component_app_image_holder, {
                image: _ctx.model.image,
                status: _ctx.model.imageStatus
              }, null, 8, ["image", "status"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.Options.Status, _ctx.model.status)
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderTimeUnit(_ctx.model.timeUnit)
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.timeDuration), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_14,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.publishTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.unpublishTime)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_app_button, {
            name: "Translate",
            theme: "info",
            icon: "fa-language",
            to: { name: _ctx.ROUTE_NAME_PROMOTION.PLAN.TRANSLATE, params: { id: _ctx.model.id } }
          }, null, 8, ["to"]),
          (_ctx.model.canEdit)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Edit",
                theme: "info",
                icon: "fa-edit",
                to: { name: _ctx.ROUTE_NAME_PROMOTION.PLAN.EDIT, params: { id: _ctx.model.id } }
              }, null, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.model.canEnable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 1,
                name: "Enable",
                theme: "success",
                icon: "fa-play",
                onClick: _ctx.actions.enable
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDisable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 2,
                name: "Disable",
                theme: "warning",
                icon: "fa-stop",
                onClick: _ctx.actions.disable
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}